import Cookies from 'js-cookie'

const SESSION_MARKER_COOKIE = 'pro_session_expiration'
const DEFAULT_LOGIN_URL = 'https://pokemonrevolution.net/en/login'

function loginBaseUrl () {
  return process.env.VUE_APP_PRO_LOGIN_URL || DEFAULT_LOGIN_URL
}

function isBrowser () {
  return typeof window !== 'undefined' && typeof window.location !== 'undefined'
}

export function isLoggedInByCookie () {
  return Boolean(Cookies.get(SESSION_MARKER_COOKIE))
}

export function sanitizedReturnPath (route) {
  const fallback = '/dashboard'
  const redirect = route && route.query ? route.query.redirect : null
  const candidate = typeof redirect === 'string' && redirect ? redirect : route && route.fullPath

  if (!candidate || candidate === '/auth/login') {
    return fallback
  }

  if (candidate.charAt(0) === '/' && candidate.charAt(1) !== '/') {
    return candidate
  }

  if (isBrowser()) {
    try {
      const parsed = new URL(candidate, window.location.origin)
      if (parsed.origin === window.location.origin) {
        return parsed.pathname + parsed.search + parsed.hash
      }
    } catch (e) {
      return fallback
    }
  }

  return fallback
}

export function dashboardReturnUrl (route) {
  const path = sanitizedReturnPath(route)
  if (!isBrowser()) {
    return path
  }

  return new URL(path, window.location.origin).toString()
}

export function buildLoginUrl (route) {
  const returnTo = dashboardReturnUrl(route)
  const loginUrl = loginBaseUrl()

  try {
    const parsed = new URL(loginUrl)
    parsed.searchParams.set('return_to', returnTo)
    return parsed.toString()
  } catch (e) {
    const separator = loginUrl.indexOf('?') === -1 ? '?' : '&'
    return `${loginUrl}${separator}return_to=${encodeURIComponent(returnTo)}`
  }
}

export function redirectToLogin (route, replace = false) {
  if (!isBrowser()) {
    return
  }

  const target = buildLoginUrl(route)
  if (replace) {
    window.location.replace(target)
  } else {
    window.location.assign(target)
  }
}
